/**
 * LA RONDA 2026-10 EN LA FICHA DEL NEGOCIO (EQUIPOS-PANEL-T1 parte 2, pedido de Ares por Josse 6-oct).
 *
 * DE DONDE SALE. Josse y Ares estan revisando los negocios uno por uno ("la ronda") y lo que confirman queda en
 * businesses.metadata.ronda_2026_10: tipo, marca, canal, version del Desktop, instalacion en C o D, Dropbox, fondo,
 * equipos, consentimiento, datos del propietario y lo pendiente. Medido 6-oct: 30 de 36 negocios traen la ronda
 * (instalacion_en_codigo y respaldo_dropbox_codigo, lo medido en el codigo) y 5 la traen completa. Josse quiere VERLO
 * en el panel mientras llegan las columnas de verdad (CLIENTES-CANAL-ACTIVACION-T1, D-85). Solo lectura.
 *
 * EL CONTRATO REAL (medido en NexoAPI main c49eed3, PostgresBusinessService.ParseJsonbColumn): la API aplana metadata a
 * un nivel y un valor que es objeto llega como su TEXTO JSON (GetRawText). Por eso ronda_2026_10 llega como string y se
 * parsea aqui; si algun dia llega como objeto, tambien sirve.
 *
 * Sin DOM: lo prueba scripts/check-ronda-negocio.mjs.
 */

/** Las claves en el orden en que Josse las revisa, con su nombre para leer. Lo que no este aqui igual se muestra al final. */
export const CAMPOS_DE_LA_RONDA = [
  ['tipo_confirmado', 'Tipo confirmado'],
  ['descripcion_marca', 'Descripcion de la marca'],
  ['canal_activacion', 'Canal de activacion'],
  ['desktop_version', 'Version del Desktop'],
  ['instalacion_en', 'Instalacion (C o D)'],
  ['instalacion_en_codigo', 'Instalacion, medida en el codigo'],
  ['respaldo_dropbox', 'Respaldo en Dropbox'],
  ['respaldo_dropbox_codigo', 'Dropbox, medido en el codigo'],
  ['fondo_actualizado', 'Fondo'],
  ['equipos_firebase', 'Equipos'],
  ['consentimiento_equipos', 'Consentimiento de equipos'],
  ['datos_propietario', 'Datos del propietario'],
  ['usuarios', 'Usuarios'],
  ['tarifa', 'Tarifa'],
  ['pagos', 'Pagos'],
  ['alias_link', 'Alias del link'],
  ['pendiente', 'Pendiente']
];
const ETIQUETA = new Map(CAMPOS_DE_LA_RONDA);
const PIE = new Set(['fecha', 'por']);

const texto = (v) => (v === null || v === undefined ? '' : String(v).trim());

/** El objeto de la ronda del negocio, venga como objeto o como texto JSON. null si no hay ronda o no se puede leer. */
export function leerRonda(negocio) {
  const md = negocio?.metadata ?? negocio?.Metadata;
  if (!md || typeof md !== 'object') return null;
  let r = md.ronda_2026_10;
  if (typeof r === 'string') {
    if (!r.trim()) return null;
    try { r = JSON.parse(r); } catch { return { _ilegible: r }; }
  }
  return r && typeof r === 'object' && !Array.isArray(r) ? r : null;
}

/** Un valor para leer: la tarifa en pesos, los objetos como texto, lo vacio fuera. */
function valorParaLeer(clave, v) {
  if (v === null || v === undefined) return '';
  if (clave === 'tarifa' && /^\d+(\.\d+)?$/.test(texto(v))) return '$' + new Intl.NumberFormat('es-CO').format(Number(v));
  if (typeof v === 'object') return JSON.stringify(v);
  return texto(v);
}

/**
 * Las filas de la ronda para pintar, en orden, y su pie.
 * -> {hay, ilegible?, filas:[{clave, etiqueta, valor, pendiente}], fecha, por, completa}
 */
export function filasDeLaRonda(negocio) {
  const r = leerRonda(negocio);
  if (!r) return { hay: false, filas: [], fecha: '', por: '', completa: false };
  if ('_ilegible' in r) return { hay: true, ilegible: true, filas: [], fecha: '', por: '', completa: false };
  const filas = [];
  const vistas = new Set();
  const poner = (clave) => {
    vistas.add(clave);
    const valor = valorParaLeer(clave, r[clave]);
    if (!valor) return;
    filas.push({ clave, etiqueta: ETIQUETA.get(clave) || clave.replace(/_/g, ' '), valor, pendiente: clave === 'pendiente' });
  };
  for (const [clave] of CAMPOS_DE_LA_RONDA) if (clave in r) poner(clave);
  for (const clave of Object.keys(r)) if (!vistas.has(clave) && !PIE.has(clave)) poner(clave);
  // "Completa" = Josse ya la reviso con el (fecha y quien), no solo lo medido en el codigo.
  return { hay: true, filas, fecha: texto(r.fecha), por: texto(r.por), completa: !!(texto(r.fecha) && texto(r.por)) };
}
